import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["width", "height", "data", "dataUnit", "dataKey", "lines", "xAxisOptions", "yAxisOptions", "gridOptions", "showXAxis", "showYAxis", "showGrid", "legend", "tooltip", "brush"],
  _excluded2 = ["strokeColor"];
import React from 'react';
import { LineChart as RechartsLineChart, Line as RechartsLine, Legend as RechartsLegend, XAxis, YAxis, Brush, Tooltip as RechartsTooltip, CartesianGrid, ResponsiveContainer } from 'recharts';
import { getColor, mapGridOptions } from './chartHelper';
import ChartTooltip from './ChartTooltip';
var LineChart = function LineChart(props) {
  var width = props.width,
    height = props.height,
    data = props.data,
    dataUnit = props.dataUnit,
    dataKey = props.dataKey,
    lines = props.lines,
    xAxisOptions = props.xAxisOptions,
    yAxisOptions = props.yAxisOptions,
    gridOptions = props.gridOptions,
    showXAxis = props.showXAxis,
    showYAxis = props.showYAxis,
    showGrid = props.showGrid,
    legend = props.legend,
    tooltip = props.tooltip,
    brush = props.brush,
    remainingProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(ResponsiveContainer, {
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement(RechartsLineChart, _extends({
    width: width,
    height: height,
    data: data,
    margin: {
      top: 15,
      right: 15,
      left: 15,
      bottom: 15
    }
  }, remainingProps), showGrid && /*#__PURE__*/React.createElement(CartesianGrid, _extends({
    strokeDasharray: "3 3"
  }, mapGridOptions(gridOptions))), /*#__PURE__*/React.createElement(XAxis, _extends({
    hide: !showXAxis,
    dataKey: dataKey
  }, xAxisOptions)), /*#__PURE__*/React.createElement(YAxis, _extends({
    hide: !showYAxis,
    unit: dataUnit
  }, yAxisOptions)), tooltip && /*#__PURE__*/React.createElement(RechartsTooltip, tooltip.props), legend && /*#__PURE__*/React.createElement(RechartsLegend, _extends({
    wrapperStyle: legend.props.verticalAlign === 'bottom' ? {
      bottom: 0
    } : legend.props.wrapperStyle
  }, legend.props)), lines.map(function (line) {
    var _line$props = line.props,
      strokeColor = _line$props.strokeColor,
      remainingLineProps = _objectWithoutProperties(_line$props, _excluded2);
    return /*#__PURE__*/React.createElement(RechartsLine, _extends({
      key: line.key,
      stroke: getColor(strokeColor)
    }, remainingLineProps));
  }), brush && /*#__PURE__*/React.createElement(Brush, {
    stroke: getColor('gray')
  })));
};
LineChart.defaultProps = {
  width: 480,
  height: 200,
  data: [],
  dataUnit: '',
  // dataKey,
  lines: [],
  // xAxisOptions,
  // yAxisOptions,
  // gridOptions,
  showXAxis: true,
  showYAxis: false,
  showGrid: false,
  brush: false,
  tooltip: /*#__PURE__*/React.createElement(ChartTooltip, null)
  // legend,
};

export default LineChart;